export const PARTNER_CONTACT_CONFIRMATION_TEST_ID = {
  partnerContactConfirmation: 'partner-contact-confirmation',
};
